import { IApplicationState } from '../../types/redux';

export function getIsFavorite(state: IApplicationState) {
  const {
    newbuilding: { isFavorite },
  } = state;

  return Boolean(isFavorite);
}
